import gql from 'graphql-tag';

// Creatives and ads per article, for the Set Facebook Page confirmation.
export const ARTICLES_FACEBOOK_PAGE_IMPACT_QUERY = gql`
  query ArticlesFacebookPageImpactQuery($filter: AllArticlesFilterInput, $limit: Int) {
    allArticles(filter: $filter, limit: $limit) {
      edges {
        node {
          id
          facebookAdsCount
          creatives {
            id
          }
        }
      }
    }
  }
`;
